const Counter = function() {

    const start = 0; // Counts up from 0
    let counters;
    let currentCounter = 0;
    let progress = 0;
    let startTime = null;
    let format = 'normal';
    let numberToDisplay;
    let end = [];
    let speed = [];

    const init = (el) => {
        counters = el.querySelectorAll('.js-count');

        for (let i = 0; i < counters.length; i++) {
            end.push(Number(parseInt(counters[i].getAttribute('data-count'), 10)));
            speed.push(Number(parseInt(counters[i].getAttribute('data-speed'), 10)));

            counters[i].textContent = '0';
        }
    };

    const animate = () => {

        // Check that both required data attributes are set.
        if (!isNaN(end[currentCounter]) && !isNaN(speed[currentCounter])) {
            // If both attributes are set, use them to calculate the animation (frames, increment, etc).
            numberToDisplay = start;
            startTime = null;
            format = _getNumberFormat(end[currentCounter]);

            // Start the animation.
            window.requestAnimationFrame(_update);
        } else {
            // If not, error and skip this element.
            console.log(`Error: either one or more of the required data attributes are not set. Please ensure both data-count and data-speed are set on the elements you wish to count. Skipping this element...`);
            _newTarget();
        }
    };

    const _update = () => {
        const now = performance.now();

        // If the animation hasn't already started, set the start time to now.
        if (!startTime) {
            startTime = now;
        }

        // Calculate the progress of the animation on a scale of 0 to 1.
        progress = (now - startTime) / speed[currentCounter];
        if (progress > 1) {
            progress = 1;
        }

        // Increment by calculated amount.
        numberToDisplay = _ease(progress) * end[currentCounter];

        // Check if animation should have finished.
        if (progress >= 1) {
            // If so, make sure the number shown to the user matches the required end point, and continue to the next target.
            counters[currentCounter].textContent = _getNumber(end[currentCounter]);
            _newTarget();
        } else {
            // Otherwise update the number for this frame and loop.
            counters[currentCounter].textContent = _getNumber(numberToDisplay);
            window.requestAnimationFrame(_update);
        }
    };

    const _newTarget = () => {
        // Increment target number and check if it exists.
        currentCounter++;

        if (currentCounter < counters.length) {
            // If it exists, animate new target.
            animate();
        }
    };

    const _ease = t => {
        return t*(2-t);
    };

    const _getNumber = n => {
        if (format === 'large') {
            // If the end number is large, use 'k' shorthand.
            n = parseInt(n / 1000, 10) + 'k';
        } else if (format === 'normal') {
            // Otherwise, just add commas to tidy it up a bit.
            n = parseInt(n, 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }

        return n;
    };

    const _getNumberFormat = n => {
        // Works out based on end number which number format should be used.
        if (n > 100000) {
            return 'large';
        } else {
            return 'normal';
        }
    };

    return {
        init,
        animate: () => {
            // Check that there is at least 1 target.
            if (counters.length) {
                // Set all the targets' initial values to 0.
                for (let i = 0; i < counters.length; i++) {
                    counters[i].textContent = _getNumber(start);
                }
                animate();
            }
        }
    }
}();

export default Counter;


// WEBPACK FOOTER //
// ./assets/js/components/_counter.js